
<template>
    <modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal">
        <template slot="body">
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form" :data-url='selectedUrl ? selectedUrl : `address`'>
                <div class="row mb-3">
                    <NameAddress v-model="dataAddress.name "/>
                    <AddressAddress v-model="dataAddress.address" />
                    <CountryAddress v-model="dataAddress.country" />
                    <StateAddress v-model="dataAddress.state" :country_id="dataAddress.country.id" />
                    <CityAddress v-model="dataAddress.city" :state_id="dataAddress.state.id" />
                    <PostalAddress v-model="dataAddress.postal_zip_code" />
                    <ContactAddress v-model="dataAddress.company_contact_id" :contact_id="dataAddress.company_id" />
                    <EmailAddress v-model="dataAddress.email" />
                    <PhoneAddress v-model="dataAddress.phone" />
                    <ExtAddress v-model="dataAddress.ext" />
                    <div class="form-group col-md-6">
                        <label class="">
                            {{ $t('is_port') }}
                        </label>
                        <app-input class="col-md-8 mt-2 pt-1" type="radio" :list="isPortList" v-model="dataAddress.isPort" />
                    </div>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { validateInputs } from "../../../../../utils"
import NameAddress from "../components/address/NameAddress.vue";
import AddressAddress from "../components/address/AddressAddress.vue";
import CountryAddress from "../components/address/CountryAddress.vue";
import StateAddress from "../components/address/StateAddress.vue";
import CityAddress from "../components/address/CityAddress.vue";
import PostalAddress from "../components/address/PostalAddress.vue";
import ContactAddress from "../components/address/ContactAddress.vue";
import EmailAddress from "../components/address/EmailAddress.vue";
import PhoneAddress from "../components/address/PhoneAddress.vue";
import ExtAddress from "../components/address/ExtAddress.vue";

export default {
    name: "companiesAddressForm",
    mixins: [FormMixin],
    components : {
        NameAddress, PhoneAddress, ExtAddress, EmailAddress, AddressAddress, PostalAddress, CountryAddress, StateAddress, CityAddress, ContactAddress
    },
    props: {
        dataAddress: {
            type: Object,
            required: true // Corregir el typo aquí
        },

        selectedUrl: {
            type: String,
            required: true // Corregir el typo aquí
        },

        company_id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            contact_id: null,
            preloader: false,
            modalId: 'comapanies-contacts-modal',
            modalTitle: this.$t('edit'),
            inputs: {
                country: { id: null, name: null },
                state: { id: null, name: null },
                city: { id: null, name: null },
                contacts: { id: null, name: null },
                isPort : 0,
            },
            isPortList : [
                { id: 0, value : 'No'},
                { id: 1, value : 'Yes'},
            ],
        }
    },
    methods: {
        validations() { 
            const validations = {
                // 'country.id' : { required: true, message: 'Country is required.' },
                // 'state.id' : { required: true, message: 'State is required.' },
                // 'city.id' : { required: true, message: 'City is required.' },
            };

            if (!validateInputs(this, this.dataAddress, validations)) {
                return;
            }
            return true
        },

         deepAllNull(value) {
            if (value === null) return true;
            if (typeof value === 'object') {
                return Object.values(value).every(this.deepAllNull);
            }
            return false;
        },

        validateForm(obj, exclude = []) {
            return Object.entries(obj)
                .filter(([key]) => !exclude.includes(key))
                .every(([, value]) => this.deepAllNull(value));
        },

        submit() {
            if (this.company_id != 0) {
                this.dataAddress.company_id = this.company_id
                this.dataAddress.city_id = this.inputs.city.id;
                this.dataAddress.country_id = this.inputs.country.id;
                this.dataAddress.state_id = this.inputs.state.id;
                this.dataAddress.company_contact_id = this.inputs.contacts.id;
                // this.save(this.dataAddress)
            } else {
                this.dataAddress.company_contact_id = this.dataAddress.company_contact_id?.id;
            }

            if (!this.validations()) {
                // Si las validaciones fallan, salimos de la función sin hacer la petición
                return;
            }

            if (this.validateForm(this.dataAddress, ['company_id'])) {
                $('#' + this.modalId).modal('hide');
                return;
            }
            this.save(this.dataAddress)
        },

        beforeSubmit() {
            this.preloader = true;
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.data.message); // Muestra el mensaje de éxito
            this.updateAddressInLocalStorage(response.data.data.address)
        },

        updateAddressInLocalStorage(updatedAddress) {
            let storedAddresses = JSON.parse(localStorage.getItem('DataCustomersAddress')) || [];
            const existingIndex = storedAddresses.findIndex(address => address.id === updatedAddress.id);
            if (existingIndex !== -1) {
                storedAddresses[existingIndex] = updatedAddress;
            } else {
                storedAddresses.push(updatedAddress);
            }
            localStorage.setItem('DataCustomersAddress', JSON.stringify(storedAddresses));
            this.$emit('address-updated-customers', updatedAddress);
            this.closeModal()
        },

        closeModal() {
            this.hideModal();
            this.$emit('close-modal-address');
            this.preloader = false;
        },

        beforeSubmit() {
            this.preloader = true;
        },
        afterFinalResponse() {
            this.preloader = false;
        },
        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        clear() {
            this.fieldStatus = {
                isSubmit: false
            }
        },
        hideModal() {
            $('#' + this.modalId).modal('hide');
        },
    },

    created() {
        // console.log('dataAddress:', this.dataAddress);
        // console.log('selectedUrl:', this.selectedUrl);
        // console.log('company_id:', this.company_id);
    }
}
</script>
